import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main className="not-found">
      <div className="not-found-body">
        <p className="not-found-code">404</p>
        <h1 className="not-found-title">Page not found</h1>
        <Link className="not-found-home" to="/">Go to home</Link>
      </div>
    </main>
  );
}
